"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var asynciterator_1 = require("asynciterator");

var asynciterator_promiseproxy_1 = require("asynciterator-promiseproxy");

var rdf_string_1 = require("rdf-string");

var rdf_terms_1 = require("rdf-terms");
/**
 * A comunica Query Operation Actor that resolves BGPs in a left-deep manner
 * based on the pattern with the smallest item count.
 */


var ActorQueryOperationBgpLeftDeepSmallest =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationBgpLeftDeepSmallest, _bus_query_operation_);

  function ActorQueryOperationBgpLeftDeepSmallest(args) {
    _classCallCheck(this, ActorQueryOperationBgpLeftDeepSmallest);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationBgpLeftDeepSmallest).call(this, args, 'bgp'));
  }
  /**
   * Create a new bindings stream
   * that takes every binding of the base stream,
   * materializes the remaining patterns with it,
   * and emits all bindings from this new set of patterns.
   * @param {BindingsStream} baseStream The base stream.
   * @param {Algebra.Pattern[]} patterns The patterns to materialize with each binding of the base stream.
   * @param {{ pattern: Algebra.Pattern, bindings: IPatternBindings }[]) => Promise<IActorQueryOperationOutput>}
   *    patternBinder A callback
   * to retrieve the bindings stream of an array of patterns.
   * @return {BindingsStream}
   */


  _createClass(ActorQueryOperationBgpLeftDeepSmallest, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(pattern.patterns.length < 2)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Actor ' + this.name + ' can only operate on BGPs with at least two patterns.');

              case 2:
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(pattern, context) {
        var _this = this;

        var patternOutputs, metadatas, smallestId, i, smallestPattern, remainingPatterns, remainingMetadatas, subContext, bindingsStream, variables, metadata;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Promise.all(pattern.patterns.map(function (subPattern) {
                  return _this.mediatorQueryOperation.mediate({
                    operation: subPattern,
                    context: context
                  });
                }));

              case 2:
                _context4.t0 = bus_query_operation_1.ActorQueryOperation.getSafeBindings;
                patternOutputs = _context4.sent.map(_context4.t0);
                _context4.next = 6;
                return ActorQueryOperationBgpLeftDeepSmallest.hasOneEmptyPatternOutput(patternOutputs);

              case 6:
                if (!_context4.sent) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return", {
                  bindingsStream: new asynciterator_1.EmptyIterator(),
                  metadata: function metadata() {
                    return Promise.resolve({
                      totalItems: 0
                    });
                  },
                  type: 'bindings',
                  variables: []
                });

              case 8:
                _context4.next = 10;
                return Promise.all(patternOutputs.map(
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee2(patternOutput) {
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!patternOutput.metadata) {
                              _context2.next = 6;
                              break;
                            }

                            _context2.next = 3;
                            return patternOutput.metadata();

                          case 3:
                            _context2.t0 = _context2.sent;
                            _context2.next = 7;
                            break;

                          case 6:
                            _context2.t0 = {};

                          case 7:
                            return _context2.abrupt("return", _context2.t0);

                          case 8:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x5) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 10:
                metadatas = _context4.sent;
                smallestId = ActorQueryOperationBgpLeftDeepSmallest.getSmallestPatternId(metadatas);
                this.logDebug(context, 'Smallest pattern: ', {
                  pattern: pattern.patterns[smallestId],
                  metadata: metadatas[smallestId]
                }); // Close the non-smallest streams

                for (i = 0; i < patternOutputs.length; i++) {
                  if (i !== smallestId) {
                    patternOutputs[i].bindingsStream.close();
                  }
                } // Take the pattern with the smallest number of items


                smallestPattern = patternOutputs.slice(smallestId)[0];
                remainingPatterns = pattern.patterns.concat([]);
                remainingPatterns.splice(smallestId, 1);
                remainingMetadatas = metadatas.concat([]);
                remainingMetadatas.splice(smallestId, 1); // Check if the output type is correct

                bus_query_operation_1.ActorQueryOperation.validateQueryOutput(smallestPattern, 'bindings'); // Materialize the remaining patterns for each binding in the stream.

                subContext = context && context.set(bus_query_operation_1.KEY_CONTEXT_BGP_CURRENTMETADATA, metadatas[smallestId]).set(bus_query_operation_1.KEY_CONTEXT_BGP_PARENTMETADATA, remainingMetadatas);
                bindingsStream = ActorQueryOperationBgpLeftDeepSmallest.createLeftDeepStream(smallestPattern.bindingsStream, remainingPatterns,
                /*#__PURE__*/
                function () {
                  var _ref2 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee3(patterns) {
                    var operation, bindings;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            // Send the materialized patterns to the mediator for recursive BGP evaluation.
                            operation = {
                              type: 'bgp',
                              patterns: patterns.map(function (p) {
                                return p.pattern;
                              })
                            };
                            bindings = patterns.map(function (p) {
                              return p.bindings;
                            });
                            _context3.t0 = bus_query_operation_1.ActorQueryOperation;
                            _context3.next = 5;
                            return _this.mediatorQueryOperation.mediate({
                              operation: operation,
                              context: subContext.set(bus_query_operation_1.KEY_CONTEXT_BGP_PATTERNBINDINGS, bindings)
                            });

                          case 5:
                            _context3.t1 = _context3.sent;
                            return _context3.abrupt("return", _context3.t0.getSafeBindings.call(_context3.t0, _context3.t1).bindingsStream);

                          case 7:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x6) {
                    return _ref2.apply(this, arguments);
                  };
                }()); // Prepare variables and metadata

                variables = ActorQueryOperationBgpLeftDeepSmallest.getCombinedVariables(patternOutputs);

                metadata = function metadata() {
                  return Promise.resolve({
                    totalItems: ActorQueryOperationBgpLeftDeepSmallest.estimateCombinedTotalItems(metadatas[smallestId], metadatas.slice(smallestId))
                  });
                };

                return _context4.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: bindingsStream,
                  variables: variables,
                  metadata: metadata
                });

              case 25:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }], [{
    key: "createLeftDeepStream",
    value: function createLeftDeepStream(baseStream, patterns, patternBinder) {
      var bindingsStream = new asynciterator_1.MultiTransformIterator(baseStream);

      bindingsStream._createTransformer = function (bindings) {
        var bindingsMerger = function bindingsMerger(subBindings) {
          return subBindings.merge(bindings);
        };

        return new asynciterator_promiseproxy_1.PromiseProxyIterator(
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee5() {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return patternBinder(ActorQueryOperationBgpLeftDeepSmallest.materializePatterns(patterns, bindings));

                case 2:
                  _context5.t0 = bindingsMerger;
                  return _context5.abrupt("return", _context5.sent.map(_context5.t0));

                case 4:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        })), {
          autoStart: true,
          maxBufferSize: 128
        });
      };

      return bindingsStream;
    }
    /**
     * Get the combined list of variables of the given pattern outputs.
     * @param {IActorQueryOperationOutput[]} patternOutputs An array of query operation outputs
     * @return {string[]} The array of variable names.
     */

  }, {
    key: "getCombinedVariables",
    value: function getCombinedVariables(patternOutputs) {
      return require('lodash.uniq')([].concat.apply([], patternOutputs.map(function (patternOutput) {
        return patternOutput.variables;
      })));
    }
    /**
     * Find the pattern index with the smallest number of elements.
     * @param {{[p: string]: any}[]} metadatas An array of optional metadata objects for the patterns.
     * @return {number} The index of the pattern with the smallest number of elements.
     */

  }, {
    key: "getSmallestPatternId",
    value: function getSmallestPatternId(metadatas) {
      var smallestId = -1;
      var smallestCount = Infinity;

      for (var i = 0; i < metadatas.length; i++) {
        var meta = metadatas[i];
        var count = ActorQueryOperationBgpLeftDeepSmallest.getTotalItems(meta);

        if (count <= smallestCount) {
          smallestCount = count;
          smallestId = i;
        }
      }

      return smallestId;
    }
    /**
     * Estimate an upper bound for the total number of items from the given metadata.
     * @param {{[p: string]: any}} smallestPattern The optional metadata for the pattern
     *                                             with the smallest number of elements.
     * @param {{[p: string]: any}[]} otherPatterns The array of optional metadata for the other patterns.
     * @return {number} The estimated number of total items.
     */

  }, {
    key: "estimateCombinedTotalItems",
    value: function estimateCombinedTotalItems(smallestPattern, otherPatterns) {
      var smallestCount = ActorQueryOperationBgpLeftDeepSmallest.getTotalItems(smallestPattern);
      return otherPatterns.map(function (otherPattern) {
        return smallestCount * ActorQueryOperationBgpLeftDeepSmallest.getTotalItems(otherPattern);
      }).reduce(function (sum, element) {
        return sum + element;
      }, 0);
    }
    /**
     * Get the estimated number of items from the given metadata.
     * @param {{[p: string]: any}} metadata An optional metadata object.
     * @return {number} The estimated number of items, or `Infinity` if metadata is falsy.
     */

  }, {
    key: "getTotalItems",
    value: function getTotalItems(metadata) {
      var totalItems = (metadata || {}).totalItems;
      return totalItems || totalItems === 0 ? totalItems : Infinity;
    }
    /**
     * Materialize all patterns in the given pattern array with the given bindings.
     * @param {Pattern[]} patterns SPARQL algebra patterns.
     * @param {Bindings} bindings A bindings object.
     * @return { pattern: Algebra.Pattern, bindings: IPatternBindings }[] An array of patterns with their bindings.
     */

  }, {
    key: "materializePatterns",
    value: function materializePatterns(patterns, bindings) {
      return patterns.map(function (pattern) {
        return ActorQueryOperationBgpLeftDeepSmallest.materializePattern(pattern, bindings);
      });
    }
    /**
     * Materialize a pattern with the given bindings.
     * @param {Pattern} pattern A SPARQL algebra pattern.
     * @param {Bindings} bindings A bindings object.
     * @return { pattern: Algebra.Pattern, bindings: IPatternBindings } A new materialized pattern.
     */

  }, {
    key: "materializePattern",
    value: function materializePattern(pattern, bindings) {
      var bindingsOut = {};
      var patternOut = Object.assign(rdf_terms_1.mapTerms(pattern, function (term, termPosition) {
        var materializedTerm = ActorQueryOperationBgpLeftDeepSmallest.materializeTerm(term, bindings);

        if (term !== materializedTerm) {
          bindingsOut[termPosition] = term;
        }

        return materializedTerm;
      }), {
        type: 'pattern'
      });
      return {
        pattern: patternOut,
        bindings: bindingsOut
      };
    }
    /**
     * Materialize a term with the given binding.
     *
     * If the given term is a variable (or blank node)
     * and that variable exist in the given bindings object,
     * the value of that binding is returned.
     * In all other cases, the term itself is returned.
     *
     * @param {RDF.Term} term A term.
     * @param {Bindings} bindings A bindings object.
     * @return {RDF.Term} The materialized term.
     */

  }, {
    key: "materializeTerm",
    value: function materializeTerm(term, bindings) {
      if (term.termType === 'Variable') {
        var value = bindings.get(rdf_string_1.termToString(term));

        if (value) {
          return value;
        }
      }

      return term;
    }
    /**
     * Check if at least one of the given outputs has an empty output, i.e., when the estimated count is zero.
     * @param {IActorQueryOperationOutputBindings[]} patternOutputs Pattern outputs.
     * @return {Promise<boolean>} A promise for indicating whether or not at least one of the outputs is empty.
     */

  }, {
    key: "hasOneEmptyPatternOutput",
    value: function () {
      var _hasOneEmptyPatternOutput = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(patternOutputs) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, patternOutput, metadata;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context6.prev = 3;
                _iterator = patternOutputs[Symbol.iterator]();

              case 5:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context6.next = 16;
                  break;
                }

                patternOutput = _step.value;

                if (!patternOutput.metadata) {
                  _context6.next = 13;
                  break;
                }

                _context6.next = 10;
                return patternOutput.metadata();

              case 10:
                metadata = _context6.sent;

                if (ActorQueryOperationBgpLeftDeepSmallest.getTotalItems(metadata)) {
                  _context6.next = 13;
                  break;
                }

                return _context6.abrupt("return", true);

              case 13:
                _iteratorNormalCompletion = true;
                _context6.next = 5;
                break;

              case 16:
                _context6.next = 22;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t0 = _context6["catch"](3);
                _didIteratorError = true;
                _iteratorError = _context6.t0;

              case 22:
                _context6.prev = 22;
                _context6.prev = 23;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 25:
                _context6.prev = 25;

                if (!_didIteratorError) {
                  _context6.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context6.finish(25);

              case 29:
                return _context6.finish(22);

              case 30:
                return _context6.abrupt("return", false);

              case 31:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[3, 18, 22, 30], [23,, 25, 29]]);
      }));

      function hasOneEmptyPatternOutput(_x7) {
        return _hasOneEmptyPatternOutput.apply(this, arguments);
      }

      return hasOneEmptyPatternOutput;
    }()
  }]);

  return ActorQueryOperationBgpLeftDeepSmallest;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.ActorQueryOperationBgpLeftDeepSmallest = ActorQueryOperationBgpLeftDeepSmallest;